import React from 'react';
import {FormOne, InfoMedia, SecSubTitle, SecTitle} from '../../components';
import {Link} from "react-router-dom";

const ContactOne = ()=> (
  <div className="background-image" style={{backgroundImage: 'url(images/bg/appoin-bg-1-1.jpg)'}}>
    <div className="container z-index-common">
      <div className="row gx-60">
        <div className="col-xl-6 align-self-center space">
          <SecSubTitle className="">Make An Appointment</SecSubTitle>
          <SecTitle className="text-capitalize h1 text-white">We Provide Best Advices For Your Future</SecTitle>
          <hr className="hr-style1"/>
          <p className="mb-4 mt-1 pb-3 text-white">
            We seamlessly integrate cross-platform solutions using our top-tier expertise to drive innovative initiatives.
            We are committed to delivering high-quality results by leveraging cutting-edge technologies and methodologies.
          </p>
          <div className="row gy-30">
            <div className="col-md-6">

              <InfoMedia className="contact-media"
                icon="fal fa-phone-volume"
                title="CALL AVAILABLE"
                info={<a href="tel:+971585703053">+971 585703053</a>}
              />
            </div>
            <div className="col-md-6">
              <InfoMedia className="contact-media"
                icon="fal fa-envelope"
                title="Write a Quick mail"
                info={<a href="mailto:sales@esyncross.com">sales@esyncross.com</a>}
              />
            </div>
            <div className="col-md-12">
              <InfoMedia  className="contact-media"
                  icon="fal fa-map-marker-alt"
                  title="Office Addresses"

                          info={<>
                            <a className={"custom-link"} target={'_blank'} href="https://www.google.com/maps/place/Sharjah+Media+City+(Shams)/@25.2784547,55.6762004,913m/data=!3m1!1e3!4m6!3m5!1s0x3ef5929a229f1c75:0xb28ae30eb6bb813a!8m2!3d25.2784456!4d55.6782898!16s%2Fg%2F11c6038qjv?entry=ttu&g_ep=EgoyMDI1MDExNS4wIKXMDSoASAFQAw%3D%3D">
                              {"Sharjah Media City, Sharjah, UAE"}
                            </a>
                            <br/>
                            <a className={"custom-link"} target={'_blank'}  href="https://www.google.com/maps/place/The+Iridium+Building/@25.1186507,55.2077128,399m/data=!3m1!1e3!4m14!1m7!3m6!1s0x3e5f6bc1af8e1daf:0x6388c09f82918589!2sThe+Iridium+Building!8m2!3d25.1186337!4d55.2072461!16s%2Fg%2F11cs6c9zdr!3m5!1s0x3e5f6bc1af8e1daf:0x6388c09f82918589!8m2!3d25.1186337!4d55.2072461!16s%2Fg%2F11cs6c9zdr?entry=ttu&g_ep=EgoyMDI1MDgxMy4wIKXMDSoASAFQAw%3D%3D">
                              {"Office 209, IRIDIUM , Al Barsha,Dubai, UAE"}
                            </a>
                          </>}
              />
            </div>
          </div>
        </div>
        <div className="col-xl-6 form-wrap1">
          <FormOne
            title="Make An Appointment"
            btnText="Make An Appointment"
          />
        </div>
      </div>
    </div>
  </div>
);


export default ContactOne;